import { registerContentRenderer, registerAnswerAid } from '@/features/flashcards/utils/contentFormatters';
import { MusicNotationRenderer } from './components/MusicNotationRenderer';
import { MusicAnswerAid } from './components/MusicAnswerAid';

registerContentRenderer('music_notation', MusicNotationRenderer);
registerAnswerAid('music_notation', MusicAnswerAid);
